import script from "./InfoMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoMessage.vue?vue&type=script&setup=true&lang=ts"

import "./InfoMessage.vue?vue&type=style&index=0&id=4979d63e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/blueshift-vesting-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4979d63e"]])

export default __exports__